import React from 'react';

interface PaginationProps {
  pagination: any;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ pagination, onPageChange }) => {
  if (!pagination || pagination.total_pages <= 1) {
    return null;
  }

  const { current_page, total_pages } = pagination;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    
    let start = Math.max(1, current_page - Math.floor(maxVisible / 2));
    let end = Math.min(total_pages, start + maxVisible - 1);
    
    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= total_pages && page !== current_page) {
      onPageChange(page);
    }
  };

  return (
    <div className="d-flex justify-content-center mt-4">
      <nav aria-label="ページネーション">
        <ul className="pagination">
          {/* 前のページ */}
          <li className={`page-item ${current_page === 1 ? 'disabled' : ''}`}>
            <button 
              className="page-link"
              onClick={() => handlePageChange(current_page - 1)}
              disabled={current_page === 1}
            >
              前へ
            </button>
          </li>

          {/* 最初のページ */}
          {getPageNumbers()[0] > 1 && (
            <>
              <li className="page-item">
                <button 
                  className="page-link"
                  onClick={() => handlePageChange(1)}
                >
                  1
                </button>
              </li>
              {getPageNumbers()[0] > 2 && (
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              )}
            </>
          )}

          {/* ページ番号 */}
          {getPageNumbers().map(page => (
            <li key={page} className={`page-item ${page === current_page ? 'active' : ''}`}>
              <button 
                className="page-link"
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            </li>
          ))}

          {/* 最後のページ */}
          {getPageNumbers()[getPageNumbers().length - 1] < total_pages && (
            <>
              {getPageNumbers()[getPageNumbers().length - 1] < total_pages - 1 && (
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              )}
              <li className="page-item">
                <button 
                  className="page-link"
                  onClick={() => handlePageChange(total_pages)}
                >
                  {total_pages}
                </button>
              </li>
            </>
          )}

          {/* 次のページ */}
          <li className={`page-item ${current_page === total_pages ? 'disabled' : ''}`}>
            <button 
              className="page-link"
              onClick={() => handlePageChange(current_page + 1)}
              disabled={current_page === total_pages}
            >
              次へ
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
